var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositwallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.75 8.09999L16.725 8.15833L14.3083 13.7667H11.9333C11.3667 13.7667 10.8333 13.875 10.3333 14.0917L11.7917 10.6083L11.825 10.5333L11.875 10.4C11.9 10.3417 11.9167 10.2917 11.9417 10.25C13.0333 7.72499 14.2667 7.14999 16.75 8.09999Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2417 13.9334C20.8667 13.8251 20.475 13.7668 20.0667 13.7668H14.3083L16.725 8.15843L16.75 8.1001C16.8667 8.14176 16.9917 8.2001 17.1167 8.24176L18.9583 9.01676C19.9833 9.44176 20.7 9.88343 21.1417 10.4168C21.2167 10.5168 21.2833 10.6084 21.35 10.7168C21.425 10.8334 21.4833 10.9501 21.5167 11.0751C21.55 11.1501 21.575 11.2168 21.5917 11.2918C21.8083 12.0001 21.675 12.8584 21.2417 13.9334Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.1333 17.8333V19.4583C24.1333 19.6249 24.125 19.7916 24.1167 19.9499C23.9583 22.8666 22.3333 24.3333 19.25 24.3333H12.75C12.5417 24.3333 12.35 24.3166 12.1583 24.2916C9.50833 24.1166 8.09167 22.6999 7.90834 20.0499C7.88334 19.8499 7.86667 19.6583 7.86667 19.4583V17.8333C7.86667 16.1583 8.88334 14.7166 10.3333 14.0916C10.8333 13.8749 11.3667 13.7666 11.9333 13.7666H20.0667C20.475 13.7666 20.8667 13.8249 21.2417 13.9333C22.9083 14.4416 24.1333 15.9916 24.1333 17.8333Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.7917 10.6084L10.3333 14.0917C8.88334 14.7167 7.86667 16.1584 7.86667 17.8334V15.3917C7.86667 13.0251 9.55 11.0501 11.7917 10.6084Z",
    fill: "#667085"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.1333 15.3916V17.8333C24.1333 15.9916 22.9083 14.4416 21.2417 13.9333C21.675 12.8583 21.8083 12 21.5917 11.2916C21.575 11.2166 21.55 11.15 21.5167 11.075C23.075 11.8833 24.1333 13.525 24.1333 15.3916Z",
    fill: "#667085"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0833 18.2416H16.625V16.8333C16.625 16.4916 16.3417 16.2083 16 16.2083C15.6583 16.2083 15.375 16.4916 15.375 16.8333V18.2416H13.9167C13.575 18.2416 13.2917 18.5249 13.2917 18.8666C13.2917 19.2083 13.575 19.4916 13.9167 19.4916H15.375V20.9999C15.375 21.3416 15.6583 21.6249 16 21.6249C16.3417 21.6249 16.625 21.3416 16.625 20.9999V19.4916H18.0833C18.425 19.4916 18.7083 19.2083 18.7083 18.8666C18.7083 18.5249 18.425 18.2416 18.0833 18.2416Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositwallet);
export default __webpack_public_path__ + "static/media/depositwallet.8b64cf673cfa439e3b04be959b5cb3ff.svg";
export { ForwardRef as ReactComponent };